import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import FileAttachment from "../../UpdateModels/FileAttachment";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { price2validation } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const validationSchema = Yup.object().shape({
  price: Yup.number().required("This is required"),

  price2: price2validation,
  language_id: Yup.string().required("This is required"),
  // files: Yup.array().min(1, 'At least one file is required').required('This is required'),
});

const JExpectationPreferences = ({
  formData,
  setFormData,
  nextPage,
  previousPage,
}) => {
  const [loading, setLoading] = useState(false);
  const formdatatomap = [
    {
      title: "Price in SAR",
      name: "price",
      placeholder:
        formData.hiring_type == 1
          ? "Enter price per hourly"
          : "Enter price per month",
    },
    // {
    //   title: "Price in SAR",
    //   name: "price2",
    //   placeholder:
    //     formData.hiring_type == 1
    //       ? "Enter price per hourly"
    //       : "Enter price per month",
    // },
    {
      title: (<>Preferred Language of Work Submission <AsteriskLabel /></>),
      name: "language_id",
      placeholder: "Select Language",
    },
    { title: "Image", name: "files", placeholder: "Select Image" },
  ];
  const [work_sample, setWork_sample] = useState({
    files: formData?.files,
  });
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [allLanguage, setAllLanguage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(
    formData?.languageindex,
  );
  const formikRef = useRef(null);

  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist,
  );

  useEffect(() => {
    setAllLanguage(languagelist);
  }, [languagelist]);

  const initialValues = {
    price: formData?.price || "",
    price2: formData?.price2 || "", // <-- ADD THIS
    language_id: formData?.language_id || "",
    files: formData?.files || [],
  };


  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setFormData((prevData) => ({
      ...prevData,
      ...values,
      files: work_sample?.files,
    }));
    nextPage();
    setLoading(false);
  };
  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  return (
    <div className="app-container ">
      <div className="col-lg-10  col-md-11 mx-auto expert-flow">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-lg-4    about-left">
              <h6>
                03/03<span>Expectations & Preferences</span>
              </h6>
              <h2>Upload documents (If any) and mention deliverables</h2>
              <p>Let experts know what are you expecting from them</p>
            </div>
            <div className="col-lg-6   about-right">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                innerRef={formikRef}
              >
                {(formik) => (
                  <Form>
                    { }

                    {formdatatomap.map((prop, key) => {
                      if (prop.name == "files") {
                        return (
                          <FileAttachment
                            setWork_sample={setWork_sample}
                            selectedfiles={work_sample?.files}
                            formData={formData}
                            setFormData={setFormData}
                            key={key}
                          />
                        );
                      }
                      if (prop.name == "language_id") {
                        return (
                          <>
                            <div className="form-group">
                              <label>{prop.title}</label>
                              <ReactSelect
                                options={
                                  Array.isArray(allLanguage) &&
                                  allLanguage.map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                }
                                placeholder="Select language"
                                value={selectedLanguage}
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "language_id",
                                    selectedOption.value,
                                  );
                                  formik.setFieldValue(
                                    "languageindex",
                                    selectedOption,
                                  );
                                  setSelectedLanguage(selectedOption);
                                }}
                                key={key}
                              />
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>
                          </>
                        );
                      }
                      if (prop.name == "price") {
                        return (
                          <>
                            <label>Price Range in SAR</label>
                            <div className="row">
                              <div className="form-group col-md-6">
                                <NumberInputBox
                                  type={"number"}
                                  title={'From'}
                                  name={prop.name}
                                  placeholder={'Enter From Price'}
                                  key={key}
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <NumberInputBox
                                  type={"number"}
                                  title={'To'}
                                  name={'price2'}
                                  placeholder={'Enter To Price'}
                                  key={key}
                                />
                              </div>
                            </div>
                          </>
                        );
                      }
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    })}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11  mx-auto">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={handleNextClick} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default JExpectationPreferences;
